import React, { useEffect } from "react";
import Elections from "../../elections/Elections";

function ElectionsPage(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="homepage-container">
      <div className="home-tab tutorial-body">
        <Elections 
          userLocation={props.userLocation} 
          coordinates={props.coordinates} 
        />
      </div>
    </div>
  );
}

export default ElectionsPage;